import Box from '@ahamove/web-components/lib/Box';
import type { ListItemProps } from '@ahamove/web-components/lib/ListItem';
import ListItem from '@ahamove/web-components/lib/ListItem';
import type { StackProps } from '@ahamove/web-components/lib/Stack';
import Stack from '@ahamove/web-components/lib/Stack';
import Typography from '@ahamove/web-components/lib/Typography';
import Image from 'next/legacy/image';
import { useTranslation } from 'next-i18next';
import { homeConfig } from '@/modules/home/homeConfig';

type Props = ListItemProps & {
  type: 'location' | 'service';
  innerProps?: StackProps;
};

export default function EmptyLocation({ type, innerProps, ...props }: Props) {
  const { t } = useTranslation(homeConfig.i18nNamespaces);

  return (
    <ListItem {...props}>
      <Stack
        direction="column"
        alignItems="center"
        px={2.5}
        py={5}
        width="100%"
        {...innerProps}
        data-test-id="emptyLocationContainer"
      >
        <Box
          sx={{
            width: 133,
            height: 73,
            mx: 'auto',
            position: 'relative',
          }}
        >
          <Image
            src={'/static/images/empty-location.png'}
            alt="empty-location"
            layout="fill"
            objectFit="contain"
          />
        </Box>
        <Typography
          variant="h4"
          color="grey.800"
          align="center"
          mt={2}
          maxWidth={230}
        >
          {type === 'location'
            ? t('booking:location.location_not_found')
            : null}
          {type === 'service' ? t('booking:location.not_arrived_here') : null}
        </Typography>
        <Typography
          variant="caption"
          color="grey.600"
          align="center"
          fontWeight={500}
          mt={0.75}
        >
          {type === 'location'
            ? t('booking:location.location_not_found_desc')
            : null}
          {type === 'service'
            ? t('booking:location.not_arrived_here_desc')
            : null}
        </Typography>
      </Stack>
    </ListItem>
  );
}
